import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {FancyTextItemObject} from '@PosterWhiteboard/items/fancy-text-item/fancy-text-item.class';

export function useGetKeyFromFancyTextItem<T extends keyof FancyTextItemObject>(key: T): FancyTextItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.FANCY_TEXT) {
      const itemCopy = item as FancyTextItemObject;
      if (itemCopy?.[key] !== undefined) {
        return itemCopy[key];
      }
    }

    return undefined;
  });
}
